import { render } from "./CreativeReportList.vue?vue&type=template&id=70911b61&scoped=true"
import script from "./CreativeReportList.vue?vue&type=script&lang=js"
export * from "./CreativeReportList.vue?vue&type=script&lang=js"

import "./CreativeReportList.vue?vue&type=style&index=0&id=70911b61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70911b61"]])

export default __exports__